import React from 'react';

interface EditModeIndicatorProps {
  modulesActivated: boolean;
  editUnlocked: boolean;
  onToggleModules: () => void;
}

function EditModeIndicator({ modulesActivated, editUnlocked, onToggleModules }: EditModeIndicatorProps) {
  return (
    <div className="mb-6 flex gap-4">
      <button
        onClick={onToggleModules}
        className={`${
          modulesActivated 
            ? 'bg-rgpd-green hover:bg-rgpd-green-dark' 
            : 'bg-rgpd-blue hover:bg-rgpd-blue-dark'
        } cursor-pointer rounded-lg border-none px-8 py-3 text-sm font-medium text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg`}
      >
        {modulesActivated 
          ? <><span role="img" aria-label="check mark">✅</span> Voir et gérer les modules</>
          : 'Accéder aux modules →'
        }
      </button>
      {modulesActivated && (
        <div className={`rounded-lg px-6 py-3 text-sm font-medium ${
          editUnlocked 
            ? 'border border-orange-300 bg-orange-100 text-orange-800' 
            : 'border border-gray-300 bg-gray-100 text-gray-600'
        }`}>
          {editUnlocked 
            ? (<><span role="img" aria-label="unlocked">🔓</span> Mode édition actif - Cliquez sur les modules pour sélectionner un thème</>) 
            : (<><span role="img" aria-label="locked">🔒</span> Mode lecture seule</>)
          }
        </div>
      )}
    </div>
  );
}

export default EditModeIndicator;
